import { NewWorkScheduleScreen } from "@components";

export const WorkSchedule = () => {
    return (
        <div>
            <NewWorkScheduleScreen />
        </div>
    );
};
